import { MenuItem, TextField, InputAdornment } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import React from 'react';
import SearchIcon from '@mui/icons-material/Search';

const FormFieldOmni = ({
	label,
	name,
	value,
	bgTransparent,
	onChange,
	type = 'text',
	variant = 'standard',
	options = [],
	placeholder = '',
	multiline = false,
	rows = 1,
	error = null,
	helperText = '',
	searchBar,
	endAdornment,
	isHeader,
	...otherProps
}) => {
	const theme = useTheme();
	const isDarkTheme = theme.palette.type === 'dark';
	const themeColor = theme.palette.text.primary;

	return (
		<TextField
			fullWidth
			label={label}
			name={name}
			value={value}
			onChange={onChange}
			type={type}
			variant={variant}
			select={type === 'select'}
			placeholder={placeholder}
			multiline={multiline}
			minRows={rows}
			InputProps={{
				style: {
					backgroundColor: !bgTransparent ? (isDarkTheme ? 'transparent' : '#FAFAFA') : 'transparent',
					color: themeColor,
				},
				startAdornment: searchBar ? (
					<InputAdornment position="start">
						<SearchIcon style={{ color: themeColor }} />
					</InputAdornment>
				) : null,
				endAdornment: endAdornment ? <InputAdornment position="end">{endAdornment}</InputAdornment> : null
			}}
			inputProps={{
				style: {
					fontSize: '14px',
					color: themeColor,
				}
			}}
			InputLabelProps={{
				style: {
					color: isHeader ? 'white' : themeColor,
					fontSize: '14px',
				}
			}}
			SelectProps={{
				MenuProps: {
					PaperProps: {
						sx: {
							backgroundColor: isDarkTheme ? '#1D1F1F !important' : '#ffffff !important',
							color: themeColor,
						}
					},
					MenuListProps: {
						sx: {
							backgroundColor: isDarkTheme ? '#1D1F1F !important' : '#ffffff !important',
							padding: 0,
						}
					}
				}
			}}
			error={!!error}
			helperText={error || helperText}
			FormHelperTextProps={{ style: { fontSize: '13px' } }}
			{...otherProps}
			sx={{
				'& .MuiInput-underline:before': {
					borderBottomColor: themeColor,
				},
				'& .MuiInput-underline:hover:not(.Mui-disabled):before': {
					borderBottomColor: themeColor,
				},
				'& .MuiInput-underline:after': {
					borderBottomColor: themeColor,
				},
				'& .MuiOutlinedInput-root': {
					'& fieldset': {
						borderColor: themeColor,
					},
					'&:hover fieldset': {
						borderColor: themeColor,
					},
					'&.Mui-focused fieldset': {
						borderColor: themeColor,
					},
				},
			}}
		>
			{type === 'select' &&
				options.length > 0 &&
				options.map(option => (
					<MenuItem
						sx={{
							color: isDarkTheme ? '#fff' : '#000',
							backgroundColor: isDarkTheme ? '#1D1F1F !important' : '#ffffff !important',
							'&:hover': {
								backgroundColor: isDarkTheme ? '#2E2F2F !important' : '#f5f5f5 !important',
							},
							'&.Mui-selected': {
								backgroundColor: isDarkTheme ? '#323338 !important' : '#e3f2fd !important',
							},
							'&.Mui-selected:hover': {
								backgroundColor: isDarkTheme ? '#404042 !important' : '#bbdefb !important',
							},
						}}
						key={option.value}
						value={option.value}
					>
						{option.label}
					</MenuItem>
				))}
		</TextField>
	);
};
export default FormFieldOmni;